import {ConfigService} from '../../config/config.service';
import {environment} from '../../../environments/environment';

export function appInitializer(
  configService: ConfigService,
) {
  return async () => {
    try {

      // ✅ Step 1 — load config
      await configService.loadConfig(environment.configFile);

    } catch (err) {
      console.error('App initialization failed', err);
    }
  };
}
